<template>
  <div class="col-md-9 main-block py-4">
    <div>
      <p class="heading">I shall {{ focus.destination.text1 }}</p>
      <div class="component9">
        <div
          v-for="aTool in focus.tools.filter(el => !el._deleted_at)"
          :key="aTool.tool_id"
        >
          <ToolBase :cardname="aTool.text">
            <base-web-component
              :tool="aTool"
              :focus="focus"
              :user="$store.getters['user/user']"
            />
          </ToolBase>
        </div>
      </div>
      <b-button
        @click="showToolShop"
        class="add-tool-btn"
        block
        variant="outline-secondary"
        >Add Tool</b-button
      >
    </div>
    <b-modal
      id="modal-center"
      centered
      title="Tool Shop"
      size="xl"
      hide-footer
      v-model="isModalToolShop"
    >
      <tool-shop :focus="focus" @addtool="handleAddToolInput"></tool-shop>
    </b-modal>
  </div>
</template>

<script>
import ToolBase from "../ToolBase";
import ToolShop from "@/components/tools/toolShop";
import BaseWebComponent from "@/components/tools/baseWeb";

export default {
  name: "ToolsArea",
  props: {
    focus: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  components: {
    ToolBase,
    BaseWebComponent,
    ToolShop
  },
  data() {
    return {
      isModalToolShop: false,
      refresh: 1
    };
  },
  methods: {
    showToolShop() {
      this.isModalToolShop = true;
    },
    handleAddToolInput(e) {
      this.isModalToolShop = false;
      let tool = { ...e };
      delete tool.text;
      delete tool.subText;
      this.$store
        .dispatch("user/addTools", {
          tools: [tool]
        })
        .then(toolswUid => {
          toolswUid.map((el, index) => {
            el.tools_id = el.uid;
            el.uid = e.text.toLowerCase().replace(" ", "") + el.uid;
            el.order = index;
            el.text = e.text;
            el.subText = e.subText;
            // delete el.uid
            delete el.tooldetail;
            return el;
          });
          this.$store.dispatch("tools/addToolIntoFocus", {
            tool: toolswUid[0],
            focusId: this.focus.focusId
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.mainbox {
  display: flex;
  padding: 0px 1rem;
}
.add-tool-btn {
  margin-top: 6px;
}
.chart-box {
  display: flex;
  flex-direction: column;
  .box-row {
    display: flex;
    flex-direction: row;
    margin: 0px 5px;
    margin-top: 5px;
    svg {
      margin: 3px 5px 0px 0px;
    }
    p {
      margin: 0px;
      font-size: 12px;
    }

    .box-small-text {
      color: #91929b;
      font-size: 12px;
      line-height: 22px;
      margin-right: 15px;
      span {
        margin-left: 15px;
      }
    }
  }
}
</style>
